import { TOKEN, apiUrl } from "../Constants";
import api from "./ApiService";

const BASE_URL = apiUrl + '/api/menus';

export function getAllMenus(status: string) {
  const config = {
    headers: { Authorization: `Bearer ${TOKEN}` },
  }

  return api.get(`${BASE_URL}/${status}`, config)
}

export function getMenuByID(id: string) {
  const config = {
    headers: { Authorization: `Bearer ${TOKEN}` },
  }

  return api.get(`${BASE_URL}/id/${id}`, config)
}

export function getMenuOfRole(data: any) {
  const config = {
    headers: { Authorization: `Bearer ${TOKEN}` },
  }

  return api.post(`${BASE_URL}`, data, config)
}

export function updateMenu(data: any) {
  const config = {
    headers: { Authorization: `Bearer ${TOKEN}` },
  }

  return api.put(`${BASE_URL}`, data, config)
}